import { BooleanFilterLookup, DatetimeFilterLookup, StringFilterLookup } from './lists/filtering';

// This isn't a filter because RecurrenceRule is an interface and not a type.
// These fields should be included in filters for concrete types that implement RecurrenceRule.
// ex: type MyRecurrenceRuleObjectFilter = Filter<RecurrenceRuleFilterFields & { myCustomField: StringFilterLookup }>
export type RecurrenceRuleFilterFields = {
    startDatetime: DatetimeFilterLookup;
    endDatetime: DatetimeFilterLookup;
    recurrenceRule: StringFilterLookup;
    createdAt: DatetimeFilterLookup;
    updatedAt: DatetimeFilterLookup;
    deletedAt: DatetimeFilterLookup;
    hasRecurrenceRule: BooleanFilterLookup;
    mayHaveFutureOccurrences: BooleanFilterLookup;
};

export enum RecurrenceUnit {
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH',
    EVERY_OTHER_DAY = 'EVERY_OTHER_DAY',
    EVERY_OTHER_WEEK = 'EVERY_OTHER_WEEK',
    EVERY_OTHER_MONTH = 'EVERY_OTHER_MONTH',
}

export function renderRecurrenceUnitAdverb(unit: RecurrenceUnit): string {
    switch (unit) {
        case RecurrenceUnit.DAY:
            return 'Daily';
        case RecurrenceUnit.WEEK:
            return 'Weekly';
        case RecurrenceUnit.MONTH:
            return 'Monthly';
        case RecurrenceUnit.EVERY_OTHER_DAY:
            return 'Every Other Day';
        case RecurrenceUnit.EVERY_OTHER_WEEK:
            return 'Every Other Week';
        case RecurrenceUnit.EVERY_OTHER_MONTH:
            return 'Every Other Month';
        default:
            return renderRecurrenceUnit(unit);
    }
}

export function renderBaseInterval(unit: RecurrenceUnit, count: number): string {
    switch (unit) {
        case RecurrenceUnit.DAY:
        case RecurrenceUnit.EVERY_OTHER_DAY:
            return `Day${count === 1 ? '' : 's'}`;
        case RecurrenceUnit.WEEK:
        case RecurrenceUnit.EVERY_OTHER_WEEK:
            return `Week${count === 1 ? '' : 's'}`;
        case RecurrenceUnit.MONTH:
        case RecurrenceUnit.EVERY_OTHER_MONTH:
            return `Month${count === 1 ? '' : 's'}`;
        default:
            return `${count} ${unit}`;
    }
}

export function renderRecurrenceUnit(unit: RecurrenceUnit): string;
// eslint-disable-next-line @typescript-eslint/unified-signatures
export function renderRecurrenceUnit(unit: RecurrenceUnit, count: number): string;
export function renderRecurrenceUnit(unit: RecurrenceUnit, count?: number): string {
    let baseText: string;
    switch (unit) {
        case RecurrenceUnit.DAY:
            baseText = 'Day';
            break;
        case RecurrenceUnit.WEEK:
            baseText = 'Week';
            break;
        case RecurrenceUnit.MONTH:
            baseText = 'Month';
            break;
        case RecurrenceUnit.EVERY_OTHER_DAY:
            return 'Every Other Day';
        case RecurrenceUnit.EVERY_OTHER_WEEK:
            return 'Every Other Week';
        case RecurrenceUnit.EVERY_OTHER_MONTH:
            return 'Every Other Month';
        default:
            return unit;
    }

    if (count !== undefined && count !== 1) {
        return `${baseText}s`;
    }
    return baseText;
}
